import React from 'react';
import GenericCrudPage from '../components/GenericCrudPage';

// Staff Leaves
export const StaffLeavesPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="leaves"
    title="Staff Leaves"
    fields={[
      { key: 'staffName', label: 'Staff Name', required: true },
      { key: 'leaveType', label: 'Leave Type', type: 'select', options: ['sick', 'casual', 'earned', 'maternity', 'paternity', 'unpaid'], required: true },
      { key: 'fromDate', label: 'From Date', type: 'date', required: true },
      { key: 'toDate', label: 'To Date', type: 'date', required: true },
      { key: 'reason', label: 'Reason', type: 'textarea' },
      { key: 'status', label: 'Status', type: 'select', options: ['pending', 'approved', 'rejected'], default: 'pending' },
    ]}
    listColumns={['staffName', 'leaveType', 'fromDate', 'toDate', 'status']}
  />
);

// Payslips
export const PayslipsPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="payslips"
    title="Payslips"
    fields={[
      { key: 'staffName', label: 'Staff Name', required: true },
      { key: 'month', label: 'Month (YYYY-MM)', required: true },
      { key: 'basic', label: 'Basic Salary', type: 'number', required: true },
      { key: 'allowances', label: 'Allowances', type: 'number', default: 0 },
      { key: 'deductions', label: 'Deductions', type: 'number', default: 0 },
      { key: 'netPay', label: 'Net Pay', type: 'number' },
      { key: 'status', label: 'Status', type: 'select', options: ['draft', 'issued', 'paid'], default: 'draft' },
    ]}
    listColumns={['staffName', 'month', 'basic', 'netPay', 'status']}
  />
);

// Staff Incentives
export const IncentivesPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="incentives"
    title="Staff Incentives"
    fields={[
      { key: 'staffName', label: 'Staff Name', required: true },
      { key: 'type', label: 'Type', type: 'select', options: ['bonus', 'commission', 'referral', 'performance'] },
      { key: 'amount', label: 'Amount', type: 'number', required: true },
      { key: 'reason', label: 'Reason', type: 'textarea' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'status', label: 'Status', type: 'select', options: ['pending', 'approved', 'paid'], default: 'pending' },
    ]}
    listColumns={['staffName', 'type', 'amount', 'date', 'status']}
  />
);

// Staff Advances
export const StaffAdvancesPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="staff-advances"
    title="Staff Advances / Loans"
    fields={[
      { key: 'staffName', label: 'Staff Name', required: true },
      { key: 'amount', label: 'Amount', type: 'number', required: true },
      { key: 'reason', label: 'Reason', type: 'textarea' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'repaymentPlan', label: 'Repayment (months)', type: 'number' },
      { key: 'status', label: 'Status', type: 'select', options: ['pending', 'approved', 'repaid'], default: 'pending' },
    ]}
    listColumns={['staffName', 'amount', 'date', 'repaymentPlan', 'status']}
  />
);

// Staff Training
export const StaffTrainingPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="training"
    title="Staff Training Records"
    fields={[
      { key: 'staffName', label: 'Staff Name', required: true },
      { key: 'topic', label: 'Training Topic', required: true },
      { key: 'trainer', label: 'Trainer' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'duration', label: 'Duration (hours)', type: 'number' },
      { key: 'certificate', label: 'Certificate URL' },
      { key: 'status', label: 'Status', type: 'select', options: ['scheduled', 'completed', 'cancelled'], default: 'scheduled' },
    ]}
    listColumns={['staffName', 'topic', 'trainer', 'date', 'status']}
  />
);
